<div class="edit-art-container">
  <app-loader *ngIf="isLoaderVisible"></app-loader>

  <div *ngIf="loggedInUser.role_id === 3; else buyerOrArtistTemplate" style="padding: 2%; text-align: justify;">
    {{'artistAccountNotValidatedYet' | translate}}
  </div>
  <ng-template #buyerOrArtistTemplate>
    <div *ngIf="!isEditArtVisible; else editArtVisibleTemplate">
      <table *ngIf="isDataReady && paintings.length > 0" cellpadding="0">
        <tr>
          <th class="mobile-half">{{'artImage' | translate}}</th>
          <th class="hide-mobile">{{'artTitle' | translate}}</th>
          <th class="hide-mobile">{{'addArtDescription' | translate}}</th>
          <th class="mobile-half">{{'artActions' | translate}}</th>
        </tr>
        <tr *ngFor="let painting of paintings" class="lazy-load hidden" #lazyElement>
          <td class="img_td">
            <img [src]="backendAddress + painting.file_path" alt="{{painting.title | translate}}">
          </td>
          <td class="hide-mobile">{{painting.title}}</td>
          <td class="hide-mobile">{{painting.description}}</td>
          <td class="actions">
            <mat-icon (click)="editArt(painting)" class="clickable">edit</mat-icon>
            <mat-icon (click)="openDialogDeleteObject(painting)" class="clickable" color="warn">delete</mat-icon>
          </td>
        </tr>
      </table>
      <p *ngIf="paintings.length === 0" class="center">{{'noArt' | translate}}</p>
    </div>
    <ng-template #editArtVisibleTemplate>
      <app-add-art *ngIf="isEditArtVisible"
                   [loggedInUser]="loggedInUser"
                   [isEditArtVisible]="isEditArtVisible"
                   [artObjectFromEdit]="toSendPainting"
                   (newItemEvent)="cancelEdit()"
      ></app-add-art>
    </ng-template>
  </ng-template>
</div>
